'use client';
import { useEffect, useState } from 'react';
import {
  useSelectedVariant,
  useAdditionalProducts
} from '@/components/product/product-context';
import Image from 'next/image';
import { useCampaign } from '@/app/CampaignContext';
import { SvgInfo } from '../opt_out_form/formSvg/formSvg';
import { MODAL_TYPES, useModal } from '@/components/modal/ModalProvider';

export default function BundleOffer({ data }) {
  const { discount_message, display_title, products, bundleOfferShopifyData } =
    data || {};
  const [totalPrice, setTotalPrice] = useState({ compareAtPrice: 0, price: 0 });
  const [outOfStock, setOutOfStock] = useState(false);
  const [offerAdded, setOfferAdded] = useState(false);
  const { selectedOptions, variant: selectedVariant } = useSelectedVariant();
  const { additionalProducts, setAdditionalProducts } = useAdditionalProducts();
  const { showPriceDetails, showModal } = useModal();
  const campaign = useCampaign();
  const [bundleOfferVariants, setBundleOfferVariants] = useState(
    products?.map((product) => {
      const shopifyProduct = product?.shopifyProduct;
      //match array for Pillow sizes
      const standardSizes = ['Twin', 'Twin XL', 'Full', 'Queen'];
      const kingSizes = ['King', 'Cal King'];
      //if offer product is a pillow, match main product Twin/Twin XL/Full/Queen to Standard pillow and King/Cal King to King pillow. Otherwise find matching size of product.
      const matchingSizeVariant =
        shopifyProduct?.productType == 'Pillow' &&
        standardSizes.includes(selectedOptions?.size)
          ? shopifyProduct?.variants?.find(
              (variant) =>
                variant?.selectedOptions?.find(
                  (option) => option?.name == 'Size'
                )?.value ==
                shopifyProduct?.options?.find(
                  (option) => option?.name == 'Size'
                )?.values?.[0]
            )
          : shopifyProduct?.productType == 'Pillow' &&
              kingSizes.includes(selectedOptions?.size)
            ? shopifyProduct?.variants?.find(
                (variant) =>
                  variant?.selectedOptions?.find(
                    (option) => option?.name == 'Size'
                  )?.value ==
                  shopifyProduct?.options?.find(
                    (option) => option?.name == 'Size'
                  )?.values?.[1]
              )
            : shopifyProduct?.variants?.find(
                (variant) =>
                  variant?.selectedOptions?.find(
                    (option) => option?.name == 'Size'
                  )?.value == selectedOptions?.size
              );
      const discount =
        bundleOfferShopifyData?.products
          ?.find(
            (offerProduct) =>
              `gid://shopify/product${offerProduct?.id}` == shopifyProduct?.id
          )
          ?.variants?.find((variant) => variant?.title == selectedOptions?.size)
          ?.discount || 0;
      return {
        discount: discount,
        product: shopifyProduct,
        productDescription: product?.product_description,
        productTabs: product?.product_tabs,

        thumbnailImage: matchingSizeVariant?.image?.url,
        variant: matchingSizeVariant
      };
    }) || []
  );

  useEffect(() => {
    const tempBundleOfferVariants = [];
    const tempTotalPrice = { compareAtPrice: 0, price: 0 };
    //match array for Pillow sizes
    const standardSizes = ['Twin', 'Twin XL', 'Full', 'Queen'];
    const kingSizes = ['King', 'Cal King'];
    let tempOutOfStock = false;

    products?.map((product) => {
      const shopifyProduct = product?.shopifyProduct;
      //if offer product is a pillow, match main product Twin/Twin XL/Full/Queen to Standard pillow and King/Cal King to King pillow. Otherwise find matching size of product.
      const matchingSizeVariant =
        shopifyProduct?.productType == 'Pillow' &&
        standardSizes.includes(selectedOptions?.size)
          ? shopifyProduct?.variants?.find(
              (variant) =>
                variant?.selectedOptions?.find(
                  (option) => option?.name == 'Size'
                )?.value ==
                shopifyProduct?.options?.find(
                  (option) => option?.name == 'Size'
                )?.values?.[0]
            )
          : shopifyProduct?.productType == 'Pillow' &&
              kingSizes.includes(selectedOptions?.size)
            ? shopifyProduct?.variants?.find(
                (variant) =>
                  variant?.selectedOptions?.find(
                    (option) => option?.name == 'Size'
                  )?.value ==
                  shopifyProduct?.options?.find(
                    (option) => option?.name == 'Size'
                  )?.values?.[1]
              )
            : shopifyProduct?.variants?.find(
                (variant) =>
                  variant?.selectedOptions?.find(
                    (option) => option?.name == 'Size'
                  )?.value == selectedOptions?.size
              );

      const discount =
        bundleOfferShopifyData?.products
          ?.find(
            (offerProduct) =>
              `gid://shopify/product${offerProduct?.id}` == shopifyProduct?.id
          )
          ?.variants?.find((variant) => variant?.title == selectedOptions?.size)
          ?.discount || 0;
      tempTotalPrice.price += parseFloat(
        (matchingSizeVariant?.price?.amount || 0) - discount
      );
      tempTotalPrice.compareAtPrice += parseFloat(
        matchingSizeVariant?.compareAtPrice?.amount || 0
      );
      const offerVariant = {
        discount: discount,
        productDescription: product?.product_description,
        productTabs: product?.product_tabs,

        thumbnailImage: matchingSizeVariant?.image?.url,
        variant: matchingSizeVariant,
        product: shopifyProduct
      };
      tempBundleOfferVariants.push(offerVariant);
      if (
        product?.variants_out_of_stock?.includes(matchingSizeVariant?.title)
      ) {
        tempOutOfStock = true;
      }
    });
    setTotalPrice(tempTotalPrice);
    setBundleOfferVariants(tempBundleOfferVariants);
    setOutOfStock(tempOutOfStock);

    if (additionalProducts?.length == 0) {
      setOfferAdded(false);
    }
  }, [
    selectedOptions?.size,
    additionalProducts,
    bundleOfferShopifyData,
    products
  ]);

  function addBundleOffer(e) {
    e.preventDefault();

    const newPayloadArr = [];
    bundleOfferVariants?.forEach((bundleVariant) => {
      const {
        variant: offerVariant,
        thumbnailImage,
        discount,
        product
      } = bundleVariant;
      const discountAmount =
        parseInt(offerVariant?.compareAtPrice?.amount, 10) -
          parseInt(offerVariant?.price?.amount, 10) >
        0
          ? parseInt(offerVariant?.compareAtPrice?.amount, 10) -
            parseInt(offerVariant?.price?.amount, 10)
          : 0;

      const displayTitle =
        selectedVariant?.type == 'Mattress'
          ? selectedVariant?.productTitle.replace('Mattress', '')?.trim()
          : selectedVariant?.productTitle;
      const variantObj = {
        compareAtPrice: offerVariant?.compareAtPrice?.amount,
        customAttributes:
          [
            {
              key: '_discount_amount',
              value: (discountAmount * 100).toString()
            },
            { key: '_productImage', value: thumbnailImage },
            { key: '_productPosition', value: '0' },
            { key: '_productType', value: product.productType },
            {
              key: '_compareAtPrice',
              value: offerVariant?.compareAtPrice?.amount
            },
            {
              key: '_bundleId',
              value: `${selectedVariant?.product?.title?.replaceAll(' ', '-')}-Bundle-Offer-${selectedVariant?.variantTitle}`
            },
            { key: 'Bundle', value: `${displayTitle} Bundle Offer` },
            {
              key: '_bundleDiscountAmount',
              value: (discount || 0).toString()
            },
            { key: '_bundleVariant', value: selectedVariant?.variantTitle },
            {
              key: '_bundleHandle',
              value: `/products/${selectedVariant?.handle}`
            }
          ] || [],
        handle: selectedVariant?.handle,
        id: offerVariant?.id,
        productId: product.id,
        image: thumbnailImage,
        price: offerVariant?.price,
        title: product.title,
        variantTitle: offerVariant?.title,
        sku: offerVariant?.sku,
        type: product.productType,
        quantity: 1,
        lineItemId: '',
        product: product
      };

      newPayloadArr.push(variantObj);
    });
    setAdditionalProducts([...additionalProducts, ...newPayloadArr]);
    setOfferAdded(true);

    setTimeout(() => {
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.remove('remove-icon');
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.add('added-icon');
    });

    setTimeout(() => {
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.remove('added-icon');
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.add('remove-icon');
    }, 1000);
  }

  function removeBundleOffer(e, data) {
    e.preventDefault();
    const { bundleOfferVariants } = data;

    let currentAdditionalProducts = additionalProducts;

    bundleOfferVariants?.forEach((bundleVariant) => {
      currentAdditionalProducts = currentAdditionalProducts?.filter(
        (item) => item?.id !== bundleVariant?.variant?.id
      );
    });

    const newPayloadArr = currentAdditionalProducts;

    setAdditionalProducts(newPayloadArr);

    setOfferAdded(false);

    setTimeout(() => {
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.remove('add-icon');
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.add('removed-icon');
    });

    setTimeout(() => {
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.remove('removed-icon');
      document
        .getElementById(`bundle-offer-item-button`)
        .classList.add('add-icon');
    }, 1000);
  }

  return (
    <>
      <div
        className={`flex w-full justify-between ${outOfStock ? 'mb-4 pt-[6px]' : 'mb-4'}`}
      >
        <div className={`flex ${outOfStock ? 'opacity-50' : ''}`}>
          <div className="sh12 self-center pr-1">{display_title}</div>
          <div className="badge-text-r border-parlor-green-60 bg-light-green self-center rounded-full border px-2 py-[2px]">
            {discount_message}
          </div>
        </div>
        <div className="flex items-center">
          {outOfStock ? (
            <div className="price-s text-grey-text! self-center">
              Size out of stock
            </div>
          ) : (
            <div>
              <div className="flex">
                <div className="price-s pt-[6px] pr-1">
                  ${totalPrice?.price}
                </div>
                <div className="price-s-crossed text-dark-grey-text pt-[6px] pr-1">
                  ${totalPrice?.compareAtPrice}
                </div>
              </div>
              <div className="body-xs text-dark-grey-text text-right underline">
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    showPriceDetails(
                      `bundle-offer`,
                      null,
                      campaign.pricing_details
                    );
                  }}
                >
                  Price Details
                </span>
              </div>
            </div>
          )}
          <div className="ml-2">
            {outOfStock ? (
              <button
                disabled
                id={`bundle-offer-item-button`}
                className={`out-of-stock mr-1 h-8 w-8 transition-all duration-300 ease-in-out`}
                aria-label={`Remove bundle offer products for $${totalPrice?.price}`}
              ></button>
            ) : offerAdded ? (
              <button
                onClick={(e) => removeBundleOffer(e, { bundleOfferVariants })}
                id={`bundle-offer-item-button`}
                className={`remove-icon mr-1 h-8 w-8 transition-all duration-300 ease-in-out`}
                aria-label={`Remove bundle offer products for $${totalPrice?.price}`}
              ></button>
            ) : (
              <button
                onClick={(e) => addBundleOffer(e)}
                id={`bundle-offer-item-button`}
                className={`add-icon mr-1 h-8 w-8 transition-all duration-300 ease-in-out`}
                aria-label={`Add bundle offer products for $${totalPrice?.price}`}
                data-cy="cross-sell-item"
              ></button>
            )}
          </div>
        </div>
      </div>
      {bundleOfferVariants?.map((product, index) => {
        function showBundleOfferModal(e, index) {
          e.preventDefault();
          showModal(MODAL_TYPES.bundleOffer, {
            product,
            productTabs: product?.productTabs,
            pricingDetailsData: campaign?.pricing_details,
            index
          });
        }
        return (
          <div
            key={index}
            className={`flex ${index !== 0 && 'pt-4'} ${outOfStock ? 'opacity-50' : ''}`}
          >
            <div className="mr-3 min-h-[64px] min-w-[85px]">
              <Image
                src={`${product?.thumbnailImage}?format=pjpg&auto=webp&disable=upscale`}
                width={85}
                height={64}
                alt={product?.product?.title?.replace(/\.[^/.]+$/, '') || ''}
                style={{
                  objectFit: 'cover'
                }}
                className="h-[64px] w-[85px]"
              />
            </div>
            <div>
              {' '}
              {outOfStock ? (
                <div
                  className={`mb-2 flex ${outOfStock ? '' : 'cursor-pointer'}`}
                >
                  <div className="body-s w-full pr-1 underline">
                    {product?.product?.title}
                    <button disabled>
                      <SvgInfo />
                    </button>
                  </div>
                </div>
              ) : (
                <div
                  className="mb-2 flex cursor-pointer"
                  onClick={(e) => showBundleOfferModal(e, index)}
                >
                  <div className="body-s w-full pr-1 underline">
                    {product?.product?.title}
                    <button>
                      <SvgInfo />
                    </button>
                  </div>
                </div>
              )}
              <div className="body-s text-dark-grey-text">
                {product?.productDescription}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
